// extracted by mini-css-extract-plugin
export default {"container":"yxa-z","oos":"zxa-z","selected":"Axa-z","recommendedSize":"Bxa-z"};